import * as React from 'react';

const ArrowUpIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="arrow-up-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.24162 13.0751C6.78601 13.5307 6.04732 13.5307 5.59171 13.0751C5.1361 12.6195 5.1361 11.8808 5.59171 11.4252L12.5917 4.42521C13.0473 3.96959 13.786 3.96959 14.2416 4.42521L21.2416 11.4252C21.6972 11.8808 21.6972 12.6195 21.2416 13.0751C20.786 13.5307 20.0473 13.5307 19.5917 13.0751L14.5833 8.06675L14.5833 22.7502C14.5833 23.3945 14.061 23.9168 13.4167 23.9168C12.7723 23.9168 12.25 23.3945 12.25 22.7502L12.25 8.06675L7.24162 13.0751Z"
        fill="#313A44"
      />
    </svg>
  );
};

ArrowUpIcon.propTypes = {};

ArrowUpIcon.defaultProps = {};

export default React.memo(ArrowUpIcon);
